/**
 * Roles
 */
export const ROLE_OP_MANAGER = 'OP_MANAGER';
export const ROLE_OP_MEMBER = 'OP_MEMBER';
export const ROLE_CS_MANAGER = 'CS_MANAGER';
export const ROLE_CS_MEMBER = 'CS_MEMBER';
export const ROLE_OP_HEAD = 'OP_HEAD';
export const ROLE_SUPER_USER = 'ADMIN';
